/* prettier-ignore */
/* eslint-disable @atlaskit/editor/no-re-export */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */

import translations from '@atlaskit/afm-i18n-platform-editor-editor-common/i18n/en_GB';
export default translations;
